import { IsOptional, IsString } from "class-validator";

export class CreateHoundDto {
  @IsOptional()
  readonly token: string;

  @IsOptional()
  readonly owner: string;

  readonly totalRuns: number;
  readonly firstPlace: number;
  readonly secondPlace: number;
  readonly thirdPlace: number;
  readonly staminaLastUpdate: Date;
  readonly staminaRefill1x: number;
  readonly stamina: number;
  readonly staminaPerTimeUnit: number;
  readonly staminaCap: number;

  @IsOptional()
  readonly breedingCooldown: string;

  readonly breedingFee: number;
  readonly lastBreed: Date;
  readonly lastEnqueue: Date;

  @IsOptional()
  readonly availableToBreed: Boolean;

  @IsOptional()
  readonly geneticSequence: string;
  
  @IsOptional()
  readonly generation: string;

  @IsOptional()
  readonly extensionTraits: string;

  @IsOptional()
  readonly maleParent: number;

  @IsOptional()
  readonly femaleParent: number;

  @IsOptional()
  readonly title: string;

  @IsOptional()
  readonly tokenUrl: string;

  @IsOptional()
  readonly custom: Boolean;

  @IsOptional()
  readonly running: Boolean;

  readonly birthDate: Date;
}
